<template>
  <div class="contractLogin">
    <div class="container">
      <!-- 面包屑导航 -->
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item
            ><span class="el-icon-s-home"></span
            ><a href="/"> 首页</a></el-breadcrumb-item
          >
          <el-breadcrumb-item><a href="/">技术合同登记</a></el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <img src="../../assets/Home/组 3826.png" alt=""> -->
      </div>
      <!-- 技术合同 -->
      <div class="Tec-contract">
        <div class="imgcontainer">
          <video
            @ended="videoOver"
            @pause="videoPause"
            @play="videoP"
            ref="videoPlay"
            src="../../../public/技术合同登记.mp4"
            :controls="flag"
          ></video>
          <img
            ref="play"
            src="../../assets/Home/shipinbofang.png"
            alt=""
            class="play"
            @click="onPlay"
          />
        </div>
        <div class="content">
          <p class="contentTitle">技术合同</p>
          <div class="bcEnglish">TECHNICAL CONTRACT</div>
          <p class="contentTxt">
            技术合同是当事人就技术开发、转让、咨询或者服务订立的确立相互之间权利和义务的合同。技术合同的特征主要有：技术合同的标的与技术有密切联系，是提供技术的行为；技术合同履行环节多，履行期限长；价款、报酬或使用费的计算较为复杂；法律调整具有多样性（受专利法、商业秘密法、反不正当竞争法、著作权法等法律的调整和约束）；当事人一方具有一定专业知识或技能的技术人员；技术合同是双方、有偿合同。
          </p>
          <div class="service">
            <img src="../../assets/Home/电话咨询 (2).png" alt="" /><span
              >技术合同登记咨询</span
            >
            <p class="servicePhone">
              河南省生产力促进中心（站点编号4100-03） 李方圆 0371-67579136
              &nbsp; 周熠冰 0371-67579080
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 技术合同分类 -->
    <div class="Classification">
      <div class="container">
        <h3 class="hbold">技术合同分类</h3>
        <ul>
          <li
            v-for="(i, n) in ProList"
            :key="n"
            :class="TabIndex == n ? 'focusTab' : ''"
            @mouseenter="mouseEnter(n)"
            @mouseleave="mouseLeave()"
          >
            <img :src="TabIndex == n ? i.img1 : i.img" alt="" />

            <h3 >{{ i.title }}</h3>
            <p>{{ i.txt }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 可享受政策 -->
    <div class="policy">
      <div class="container">
        <h3 class="hbold">技术合同登记可享受的政策</h3>
        <div class="txt1">
          <p v-for="(item, n) in msg1" :key="n">{{ item }}</p>
        </div>
        <div class="img1">
          <p>税收优惠</p>
          <img src="../../assets/Home/税收财务.png" alt="" />
        </div>
        <div class="img2">
          <p class="pTitle">技术转移奖补</p>
          <p class="PTxt">
            （依据《郑州市科技成果转移转化补助实施细则》（郑科规{2019}2号））
          </p>
          <img src="../../assets/Home/税收财务.png" alt="" />
        </div>
        <div class="txt2">
          <p v-for="(item, n) in msg2" :key="n">{{ item }}</p>
        </div>
      </div>
    </div>
    <!-- 申报条件 -->
    <div class="conditions">
      <div class="container">
        <h3 class="hbold">技术合同登记申报条件</h3>
        <p>
          依据《中华人民共和国合同法》的规定，签定的技术开发、技术转让、技术咨询和技术服务合同，并使用中华人民共和国科学技术部印制的格式文本（格式文本可在
          中国技术市场管理促进中心官http://210.76.97.54/downfile.htm下载）。
        </p>
      </div>
    </div>
    <!-- 流程 -->
    <div class="regProcess">
      <div class="container">
        <h3 class="hbold">技术合同登记流程</h3>
        <img src="../../assets/Home/5.png" alt="" />
        <div class="material">
          <h3 class="hbold">办理材料</h3>
          <div class="materials">
            <div class="mLeft">
              <img src="../../assets/Home/组 16@2x.png" alt="" />
            </div>
            <div class="mRight">
              <div class="first" v-for="(item, n) in needList" :key="n">
                <h4>{{ item.title }}</h4>
                <p class="option">{{ item.need }}</p>
                <p class="option">{{ item.n1 }}</p>
                <p class="option">{{ item.n2 }}</p>
                <p class="option">{{ item.n3 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注意事项 -->
    <div class="tips">
      <div class="container">
        <h4 class="hbold notice">注意事项</h4>
        <p v-for="(item, n) in tips" :key="n">{{ item }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ProList: [
        {
          title: "技术咨询",
          img: require("../../assets/Home/组 23598.png"),
          img1: require("../../assets/Home/技术支持 支持 智能客服 服务.png"),
          txt: "一方当事人（受托方）为另一方（委托方）就特定技术项目提供可行性论证、技术预测、专题技术调查、分析评价报告等所订立的合同。",
        },
        {
          title: "技术开发",
          img: require("../../assets/Home/284开发-线性.png"),
          img1: require("../../assets/Home/284开发-线性(1).png"),
          txt: "当事人之间就新技术、新产品、新工艺、新材料、新品种及其系统的研究开发所订立的合同。包括合作开发和委托开发合同。",
        },
        {
          title: "技术转让",
          img: require("../../assets/Home/组 23594.png"),
          img1: require("../../assets/Home/组 23596.png"),
          txt: "当事人之间就专利权转让、专利申请转让、专利实施许可、技术秘密转让所订立的合同。是现有的、特定的、权力化的技术在不同的法律主体之间的转移。",
        },
        {
          title: "技术服务",
          img: require("../../assets/Home/组 23595.png"),
          img1: require("../../assets/Home/组 23597.png"),
          txt: "一方当事人（委托方）以技术知识为另一方（委托方）解决特定技术问题所订立的合同。包括技术中介、技术培训合同。",
        },
      ],
      showImg: false,
      TabIndex: 0,
      flag: false,
      msg1: [
        "① 经登记备案、通过免税审核的技术开发和技术转让合同，可免征增值税。（依据《关于全面推开营业税改征增值税试点的通知》（财税[2016]36号）)",
        "② 经登记备案、通过免税审核的技术转让合同，免征、减征企业所得税（依据：1.主席令63号《企业所得税法》2.国务院令第512《企业所得税法实施条例》3.国税函[2009]212号4.财税[2010]111号5.国税公告2013年第62号）",
        "③ 技术服务、技术咨询合同暂无税收优惠。",
      ],
      msg2: [
        "① 针对技术开发和技术转让合同，依据上年度总技术交易额的1‰给予奖励，同一单位最高不超过50万元；技术服务和技术咨询合同按实际到款额0.5‰给予补助，同一单位最高补助10万元。",
        "② 鼓励企业引进先进技术成果在我市转移转化，按照上年度技术转让合同实际付款额5%给予补助，单个技术合同补贴不超过20万元，同一单位年度最高补助100万元。",
        "③ 对促成技术转移转化的技术转移服务机构，按照技术合同交易额的3%给予补助，同一技术转移服务机构每年补助金额不超过100万元。",
        "④ 鼓励国（境）外各类组织和机构在郑州市设立或共建国际技术转移机构，对其促成的国际技术合同，按照交易额的10%进行补助，单个机构年最高补助金额不超过100万元。",
      ],
      needList: [
        {
          title: "01 首次办理",
          need: "需提供:",
          n1: "① 企业营业执照（复印件加盖公章)",
          n2: "② 法人身份证复印件",
          n3: "在河南省生产力促进中心登记处备案并注册账号和密码",
        },
        {
          title: "02 非首次办理",
          need: "需提供:",
          n1: "① 技术合同原件1份及复印件2份（合同复印件需在封面加盖公章并加盖骑缝章）",
          n2: "②《河南省技术合同认定登记申请表》2份（可从中国技术市场管理促进中心官网  http://210.76.97.54/downfile.htm  下载）申请表需具备三章一字即公章、财务章、法人章及财务或经办人签字",
        },
      ],
      tips: [
        "1.申请认定登记的技术合同应当是依法已经生效的合同。",
        "2.具备完整的书面合同文本和相关附件。印章不齐备或者印章与书写名称不一致，不予登记。",
        "3.合同主体不明确的，标的不明确的，价款、报酬、使用费等约定不明确的，不予以登记。",
      ],
    };
  },

  methods: {
    mouseEnter(n) {
      this.TabIndex = n;
      this.showImg = false;
    },
    //   鼠标移除
    mouseLeave() {
      this.TabIndex = null;
      this.showImg = true;
    },
    onPlay() {
      this.$refs.videoPlay.play();
      this.$refs.play.style.display = "none";
      this.flag = true;
    },
    videoOver() {
      this.$refs.play.style.display = "block";
      this.flag = false;
    },
    videoPause() {
      this.$refs.play.style.display = "block";
    },
    videoP() {
      this.$refs.play.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
.contractLogin {
  width: 100%;
}
.container {
  font-size: 1rem;
  width: 87.5rem;
  margin: 0 auto;
  font-family: Microsoft YaHei;
  .nav {
    /* text-align: start; */
    padding: 1.5625rem 0 1.25rem 0;
  }
  .Tec-contract {
    display: flex;
    /* justify-content: space-around; */
    .imgcontainer {
      cursor: pointer;
      width: 40.5625rem;
      /* height: 22.8125rem; */
      margin-right: 3.1875rem;
      padding: 1.5625rem 0 0.5625rem;
      position: relative;

      video {
        width: 40.5625rem;
        height: 22.8125rem;
      }
      img {
        width: 100%;
      }
      .play {
        width: 5rem;
        position: absolute;
        top: 38%;
        left: 42%;
        z-index: 2000;
      }
    }
    .content {
      margin-top: 1.0625rem;
      text-align: left;
      width: 43.75rem;
      position: relative;
      .bcEnglish {
        /* width: 27.9375rem; */
        /* height: 5.25rem; */
        position: absolute;
        top: -0.45rem;
        left: 0;
        text-align: left;

        font-size: 3.125rem;
        font-family: PingFang SC;
        /* font-weight: 800; */
        /* line-height: 0px; */
        color: #273b55;
        /* letter-spacing: 2.5rem; */
        opacity: 0.05;
      }
      .contentTitle {
        font-size: 2.375rem;
        font-weight: bold;
        color: #333333;

        margin-bottom: 1.6875rem;
      }
      .contentTxt {
        color: #888888;
        line-height: 1.875rem;
      }
      .service {
        margin-top: 2.9375rem;
        img {
          vertical-align: middle;
          margin-right: 0.6125rem;
        }
        span {
          padding-top: 0.125rem;
          font-size: 1.25rem;
        }
        .servicePhone {
          margin-top: 1.1875rem;
        }
      }
    }
  }
}
.Classification {
  margin-top: 2.9375rem;
  .container {
    overflow: hidden;
  }
  background: #f9f9f9;
  h3 {
    margin-top: 3.75rem;
    font-size: 2.375rem;
    color: #333333;
    margin-bottom: 2.875rem;
    font-weight: bold;
  }
  ul {
    display: flex;
    margin-bottom: 3.75rem;
    .focusTab {
      z-index: 33;
      h3 {
        color: #ffffff;
      }
      p {
        color: #ffffff;
      }
      background: #2769dc;
      box-shadow: 0px 0.1875rem 1rem rgba(0, 0, 0, 0.08);
      opacity: 0.8;
    }
    li {
      cursor: pointer;
      width: 20.4375rem;
      height: 23.75rem;
      padding-top: 2.75rem;
      margin-right: 1.9375rem;
      background: #ffffff;
      box-shadow: 0px 0.1875rem 1rem rgba(0, 0, 0, 0.08);
      img {
        width: 4.0625rem;
        height: 4.1875rem;
      }
      h3 {
        margin-top: 1.75rem;
        margin-bottom: 1.6875rem;
        font-size: 1.875rem;
        color: #333333;
        font-weight: 400;
      }
      p {
        line-height: 1.625rem;
        text-align: left;
        padding: 0 1.5rem;
        width: 17.5rem;
        color: #666666;
      }
    }
  }
}
.policy {
  height: 56.3125rem;
  margin-bottom: 2.3125rem;
  .container {
    position: relative;
    height: 100%;
    h3 {
      margin-top: 3.75rem;
      font-size: 2.375rem;
      color: #333333;
      margin-bottom: 4.375rem;
      font-weight: bold;
    }
    .txt1 {
      position: absolute;
      top: 11.25rem;
      left: 0;
      width: 43.0625rem;
      /* height: 13.875rem; */
      /* background-color: lightcoral; */
      p {
        line-height: 2rem;
        text-align: left;
        margin-bottom: 1.25rem;
      }
    }
    .img1 {
      position: absolute;
      width: 38.75rem;
      height: 16.5rem;
      background-color: rgba(39, 130, 220, 0.1);
      top: 11.25rem;
      right: 0;
      /* opacity: 0.1; */
      p {
        margin-top: 2.9375rem;
        margin-bottom: 1.5rem;
        font-size: 1.5625rem;
        color: #2769dc;
        opacity: 1;
      }
      img {
        width: 5.6875rem;
        height: 5.1875rem;
      }
    }
    .img2 {
      position: absolute;
      width: 38.75rem;
      height: 20rem;
      top: 32.5625rem;
      left: 0;
      background-color: rgba(39, 130, 220, 0.1);
      p {
        color: #2769dc;
        opacity: 1;
      }
      .pTitle {
        margin-top: 3.6875rem;
        margin-bottom: 1rem;
        font-size: 1.5625rem;
      }
      img {
        width: 5.6875rem;
        height: 5.1875rem;
        margin-top: 2.125rem;
      }
    }
    .txt2 {
      width: 43.0625rem;
      /* height: 21.375rem; */
      position: absolute;
      top: 32.5625rem;
      right: 0;
      /* background-color: rgb(136, 233, 217); */
      p {
        line-height: 2rem;
        text-align: left;
        margin-bottom: 1.25rem;
      }
    }
  }
  background: #ffffff;
}
.conditions {
  overflow: hidden;
  height: 17.25rem;
  background: #f9f9f9;

  h3 {
    margin-top: 3.75rem;
    font-size: 2.375rem;
    color: #333333;
    margin-bottom: 3.125rem;
    font-weight: bold;
  }
  p {
    padding: 0px 6.625rem;
    text-align: center;
    width: 73rem;
  }
}
.regProcess {
  overflow: hidden;
  h3 {
    margin-top: 3.75rem;
    font-size: 2.375rem;
    color: #333333;
    margin-bottom: 4.5625rem;
    font-weight: bold;
  }
  img {
    margin-bottom: 3.75rem;
    width: 100%;
  }
  background: #ffffff;
  .material {
    overflow: hidden;
    height: 45rem;
    margin-bottom: 3.75rem;
    background: url("../../assets/Home/矩形 15.png") no-repeat center;
    background-size: cover;
    h3 {
      margin-top: 3.75rem;
      margin-bottom: 3.125rem;
      font-weight: bold;
      font-size: 2.375rem;
      color: #ffffff;
    }
    .materials {
      display: flex;
      .mLeft {
        margin-left: 3.375rem;
        margin-right: 2.6875rem;
        width: 43.8125rem;
        height: 29.1875rem;
      }
      .mRight {
        .first {
          margin-bottom: 1.9375rem;
          h4 {
            margin-top: 0;
            width: 11.25rem;
            height: 2.25rem;
            background: #ffffff;
            font-weight: normal;
            border-radius: 1.125rem;
            font-size: 1.25rem;
            color: #2769dc;
            line-height: 2.25rem;
            margin-bottom: 1.3125rem;
          }
          .option {
            width: 34.875rem;
            margin-bottom: 0.3125rem;
            font-size: 1.125rem;
            text-align: left;
            color: #fff;
          }
        }
      }
    }
  }
}
.tips {
  overflow: hidden;
  /* height: 19.6875rem; */
  background: #f6f6f6;
  .container {
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
    /* height: 12.1875rem; */
    background: #ffffff;
    box-shadow: 0px 0.1875rem 1rem rgba(0, 0, 0, 0.04);
    border-radius: 0.375rem;
    padding: 1.875rem;
    .notice{
      margin: 0;
margin-bottom: 1.5rem;
    }
    h4 {
      

      color: #333333;
      text-align: left;
      font-size: 1.25rem;
    }
    p {
      text-align: left;
      margin-bottom: 0.3125rem;
      color: #666666;
      
line-height: 2rem;
    }
  }
}
.hbold{
  font-weight: bold;
}
</style>
